const dropdownOptions = {
  category: ['전공', '교양', '기초'],
  department: {
    '전공': ['AI데이터융합전공',
      'AI융합전공(Software&AI)',
      'Business & AI 전공',
      'Finance & AI융합전공',
      'Global Business & Technology전공',
      'ICT&AI세부모듈',
      'TESOL영어학전공',
      '게임한류문화산업세부모듈',
      '광고.PR.브랜딩전공',
      '교육학',
      '국가리더전공(글로벌)',
      '국제금융학과',
      '그리스.불가리아학과',
      '글로벌e스포츠매니지먼트전공',
      '글로벌스포츠산업전공',
      '글로벌스포츠산업학부',
      '기후변화융합전공',
      '남아프리카어전공',
      '독일어통번역학과',
      '동아프리카어전공',
      '디지털콘텐츠학부',
      '러시아학과',
      '루마니아학과',
      '말레이·인도네시아어통번역학과',
      '문화콘텐츠학전공',
      '미국·영연방전략세부모듈',
      '바이오메디컬공학전공',
      '반도체전자공학부(반도체공학전공)',
      '반도체전자공학부(전자공학전공)',
      '방송·영상·뉴미디어전공',
      '브라질학과',
      '사학과',
      '산업경영공학과',
      '생명공학과',
      '서아프리카어전공',
      '세계문화예술경영전공',
      //'세르비아·크로아티아학과', 중복키 오류나서 일단 지웠음..
      '수학과',
      '스페인통번역학과',
      '아랍어통번역세부모듈',
      '아프리카학부',
      '언론·정보전공',
      '언어인지과학과',
      '영미권통상통번역전공',
      '영미문학·번역전공',
      '영어통번역세부모듈',
      '영어통번역학부',
      '영어통번역학전공',
      '우크라이나학과',
      '융합비즈니스세부모듈',
      '융합인재학부',
      '이탈리아·EU전략세부모듈',
      '이탈리아어통번역학과',
      '인도학과',
      '일본어통번역학과',
      '전자물리학과',
      '정보통신공학과',
      '정치외교학과',
      '중국어통번역세부모듈',
      '중국어통번역학과',
      '중동·이슬람전략세부모듈',
      '중앙아시아학과',
      '중화권전략세부모듈',
      '철학과',
      '체코·슬로바키아학과',
      '컴퓨터공학전공',
      '태국어통번역학과',
      '테크노미디어디자인세부모듈',
      '통계학과',
      '투어리즘 & 웰니스학부',
      '패션관광문화산업세부모듈',
      '폴란드학과',
      '프랑스학과',
      '한국학과',
      '행정학과',
      '헝가리학과',
      '화학과',
      '환경학과'],
    '교양': ['마이크로디그리(영어)',
      '언어와문학',
      '문화와예술',
      '역사와철학',
      '과학과기술',
      '인간과사회',
      '인성교육',
      'HUFS CAREER',
      '미래시뮬레이션',
      '실용외국어(선택)',
      '외국인을 위한 한국학',
      '생활과스포츠',
      '군사학',
      '대학외국어',
      '미네르바인문',
      'RC영어',
      '소프트웨어기초',
      'COLLEGE ENGLISH'],
    '기초': ['인문대학',
      '국가전략언어대학',
      '경상대학',
      '공과대학(공과계열)',
      'CULTURE&TECHNOLOGY융합대학',
      'AI융합대학',
      '폴란드학과',
      '루마니아학과',
      '체코·슬로바키아학과',
      '헝가리학과',
      //'세르비아·크로아티아학과',
      '중앙아시아학과',
      '우크라이나학과',
      '한국학과',
      '이공계열']
  },
  subject: {
    'AI데이터융합전공':[
      /* 1학기 */
      "인공지능개론",
      "인공지능수학",
      "머신러닝",
      "통계모델링",
      "자료구조와알고리즘",
      "빅데이터시각화",
      "AI데이터융합세미나",
      "자연어처리의기초",
      "비정형데이터마이닝",
      "빅데이터마이닝",
      "컴퓨터비전",
      "AI데이터종합설계",
      "딥러닝고급",
      "최신기술콜로키움",
      /* 2학기*/
      "확률과통계",
      "인공지능윤리와철학",
      "객체지향프로그래밍",
      "텍스트마이닝기초",
      "빅데이터분석기초",
      "인공지능프로그래밍",
      "객체지향프로그래밍",
      "딥러닝기초",
      "빅데이터모델링",
      "자연어처리기초",
      "AI데이터기초설계",
      "거대언어모델의기초",
      "강화학습",
      "네크워크마이닝",
      "시계열데이터마이닝",
      "연구프로젝트및실습",
      "AI데이터융합논문",
      "로보틱스",
      "스타트업비지니스",
      "최신기술콜로지움2"
    ],
    'AI융합전공(Software&AI)':[
      "컴퓨터구조",
      "기계학습",
      "데이터베이스",
      "소프트웨어공학",
      "컴퓨터네크워크",
      "빅데이터",
      "정보보안"
    ],
      'Business & AI 전공':[
        "자료구조",
        "AI마케팅",
        "비즈니스딥러닝",
        "비즈니스머신러닝이론및실습"
      ],
      'Finance & AI융합전공':[
        "고급인공지능수학",
        "금융시계열분석",
        "이산수학",
        "중급파이썬프로그래밍",
        "딥러닝머신러닝",
        "투자론과최적화",
        "컨벡스최적화"
      ],
      'Global Business & Technology전공':[
        "국제경영학",
        "컴퓨터 프로그래밍",
        "관리회계",
        "교차문화커뮤니케이션",
        "소비자행동론",
        "조직행위론",
        "글로벌리더쉽원론",
        "모바일프로그래밍",
        "비즈니스소통",
        "빅데이터분석",
        "재무회계",
        "e마케팅",
        "마케팅전략실습",
        "빅데이터기반의사결정",
        "웹프레임워크",
        "인공지능",
        "졸업프로젝트실습(갭스톤디자인)"
      ],
      'ICT&AI세부모듈':[
        "Date Structure",
        "Probability & Statics",
        "Database",
        "Machine Learning",
        "Big Data"
      ],
      'TESOL영어학전공':[
        "TESOL읽기쓰기지도법",
        "영어학개론(2)",
        "TESOL현장실습",
        "세계영어",
        "심리언어학",
        "영어교수법",
        "영어어휘연구",
        "영어의미연구",
        "영어학습평가"
      ],
      '게임한류문화산업세부모듈':[
        "The World of Caltural contents",
        "Games & Storytelling",
        "Korean Cinema & TV Contents",
        "K-pop Contents Decoding Practice",
        "Psychological &Social Aspects of Games",
        "Business & Marketing in the Video Game Industry"
      ],
      '광고.PR.브랜딩전공':[
        "PR사례연구",
        "브랜드의이해",
        "광고캠페인전략론"
      ],
      '교육학':[
        "교육봉사활동",
        "교육심리",
        "인간과교육",
        "교육평가",
        "디지털교육",
        "외국어교과교육론",
        "외국어교재연구및지도법",
        "외국어논리및논술",
        "철학교재연구및지도법",
        "특수교육의이해",
        "학교폭력예방및학생의 이해",
        "교육행정및학교경영",
        "교직실무",
        "생활지도와상담",
        "과학교재연구및지도법",
        "수학교재연구및지도법"
      ],
      '국가리더전공(글로벌)':[
        "국가조직과법질서",
        "범죄와형벌II",
        "부동산과규범",
        "국제관계의규율",
        "범률중국어",
        "채권발생과실현",
        "행정과권리",
        "행정조직과절차",
        "헌법소송론",
        "지식재산의보호와활용"
      ],
      '국제금융학과':[
        "회계원리",
        "거시경제학",
        "국제경영론",
        "국제무역론",
        "조직행위론",
        "증권시장론",
        "투자론",
        "기업법",
        "무역실무",
        "원가관리회계",
        "파생금융상품론",
        "파이내스어낼리스틱",
        "경영금융실무특강",
        "금융리스크관리",
        "금융시계열분석",
        "기업분석및가치평가",
        "은행론"
      ],
      '그리스·불가리아학과':[
        "영어어휘의그리스어어원연구",
        "중동부유럽종교와민족이해",
        "초급그리스어",
        "초급그리스어회화(2)",
        "초급불가리아어(2)",
        "초급불가리아어텍스트이해(2)",
        "현대그리스와그리스학입문",
        "그리스와지중해세계유산",
        "불가리아와러시아",
        "중급그리스어문법과강독(2)",
        "중급그리스어작문과회화(2)",
        "중급불가리아어(2)",
        "중급불가리아어회화(2)",
        "중세그리스와비잔티온제국사연구",
        "그리스관광정보기획(종합설계)",
        "발칸다문화문명론",
        "불가리아영화와드라마",
        "비즈니스와사회생활을위한그리스어실습2",
        "인공지능을활용한고급그리스어통번역연습2",
        "중동부유럽이슈세미나",
        "테마별중급불가리아어(2)",
        "현대그리스사회와문화연구(종합설계)",
        "흑해지역지정학세미나",
        "FLEX불가리아어(2)",
        "그리영화와영상미디어연구(종합설게)",
        "글로벌지역데이터프로세싱실습(종합설계)",
        "불가리아무역실습(종합설계)(2)",
        "불가리아문화콘텐츠"
      ],
      '글로벌e스포츠매니지먼트전공':[
        "글로벌e스포츠미디어산업과중계권",
        '글로벌e스포츠거버넌스',
        '글로벌e스포츠이벤트개최및운영실습',
        "글로벌e스포츠게임기획및제작실습"
      ],
      '글로벌스포츠산업전공':[
        "스포츠경제학(캡스톤디자인)",
        "스포츠이벤트실습및스폰서십실무",
        "스포츠행정학개론",
        "스포츠PR커뮤니케이션실습(캡스톤디자인)",
        "스포츠경영경제분석",
        "스포츠경영사례분석(캡스톤디자인)"
      ],
      '글로벌스포츠산업학부':[
        "국제스포츠산업론",
        "글로벌스포츠프랙티스실습1",
        "글로벌스포츠프랙티스실습2",
        "스포츠AI활용실습1",
        "중급스포츠산업전공영어실습",
        "글로벌스포츠프랙티스실습3",
        "글로벌스포츠프랙티스실습4",
        "스포츠AI활용실습2",
        "스포츠산업실무영어",
        "스포츠비즈니스영어프리젠테이션실습2",
        "스포츠경영인턴십2",
        "스포츠융합산업프로젝트실습",
      ],
      '기후변화융합전공':[
        /* 1학기 */
        "기후경제학원론1",
        "기후변화개론1",
        "기후계량경제학",
        "에너지경제성평가론",
        "에너지시스템관리론",
        "지속가능ESG기술경영론",
        /* 2학기 */
        "기후변화개론2",
        "기후변화유발물질측정및분석",
        "에너지빅데이터분석",
        "ESG경영과리스크관리",
        "기후빅데이터프로그래밍및실습",
        "기후에너지정책론",
        "지속가능전력시스템최적화"
      ],
      '남아프리카어전공':[
        "남부아프리카개론",
        "남부아프리카의해외직접투자",
        "남아프리카정치2",
        "아프리카분쟁연구",
        "아프리카이주와디아스포라:상호문화이해와접근",
        "남부아프리카경제발전론",
        "남아프리카국제관계2",
        "아프리카와NGOs",
        "아프리카와아시아의경제:성과와관계",
        "남아프리카지역세미나",
      ],
      '독일어통번역학과':[
        "독일어연습2",
        "문법과텍스트이해2",
        "전공교양세미나2",
        "독이러권지역연구초기세미나",
        "독일어독해연습2",
        "독일어연습4",
        "독일어읽기2",
        "전공교양세미나4",
        "EU와현대독일의이해-이슈와과제",
        "독어학특강B",
        "독일어번역실습2",
        "독일어의미론",
        "독일어통번역실습2",
        "독일언어의이해2",
        "독일음악의이해",
        "독일인문학원어세미나",
        "독일사회문화원어세미나",
        "한.독번역연습",
        "현대독문학",
      ],
      '동아프리카어전공':[
        "동아프리카문화",
        "스와힐리어강독(A1)",
        "스와힐리어권역사",
        "스와힐리어언어실습(A1)",
        "스와힐리어강독(B1)",
        "스와힐리어문법(B1)",
        "스와힐리어회화(B1)",
        "FLEX스와힐리어(2)",
        "동아프리카천연자워과개발",
        "멀티미디어스와힐리어(B2)",
        "동아프리카토지문제와개발",
        "스와힐리어권지역세미나",
      ],
      '디지털콘텐츠학부':[
        "AI in Content Creation",
        "Global Leadership and Digital Citizenship",
        "Charater Design for Visual Contents",
        "Content Data Statistics",
        "Digital Drawing Basics",
        "Digital Evolutionof K-content",
        "Game Building & Storytelling",
        "Global Cinema Asia II",
        "History of Korean Cinema II",
        "Korean History and Dighital Contents",
        "Korean Music and Digital Contents",
        "Market Research for Cultural Contents",
        "Mythology and Heroes in Storytelling",
        "Scene Analysis and Storyboarding",
        "Content Branding Practices",
        "E-commerce in Cultural Contents",
        "Stardom and Fandom",
        "Story Creation Practices II",
        "XP Production and Applications",
        "Cultural Content Field Experience",
        "Digital Content Branding",
      ],
      '러시아학과':[
        "러시아문화(2)",
        "러시아어말하기(2)",
        "러시아어문법(2)",
        "러시아어언어실습(2)",
        "러시아어문학텍스트강독및분석(2)",
        "러시아어실용문심화(원강)",
        "러시아어말하기심화(2)",
        "러시아어쓰기심화(2)",
        "러시아어텍스트분석(2)",
        "20세기러시아문학과사회",
        "러시아CIS지역연구",
        "러시아어음성학",
        "러시아역사(2)",
        "실무러시아어말하기",
        "한.러번역연습",
        "FLEX러시아어세미나",
        "러시아경제",
        "러시아공연예술및영화",
        "러시아매스미디어언어분석",
        "러시아문화연구세미나",
      ],
      '루마니아학과':[
        "루마니아학입문(2)",
        "초급루마니아어번역연습(2)",
        "초급루마니아어회화(2)",
        "초급시청각루마니아어(2)",
        "고급루마니아어문법작문",
        "루마니아어문화",
        "중급루마니아어번역연습(2)",
        "중급루마니아어회화(2)",
        "FLEX루마니아어(2)",
        "고급루마니아어회화(2)",
        "루마니아문학개론",
        "루마니아민속연구",
        "루마니아사회문화세미나",
        "루마니아인문과지리",
        "루마니아정치경제의이해(2)",
        "루마니아어사",
        "루마니아지성과현대철학",
        "루마니아지역연구",
        "영화를통해본루마니아사회와문화",
      ],
      '말레이·인도네시아어통번역학과':[
        "기초번역과실습(2)",
        "인도네시아세미나2",
        "초급마.인어듣기와말하기(2)",
        "초급마.인어의이해(2)",
        "초급마.인어읽기와쓰기(2)",
        "초급마>인어텍스트연습(2)",
        "초급말레이어듣기와말하기(2)",
        "초급인도네시아어듣기와말하기(2)",
        "기초통번역실습",
        "마.인고전문학의이해",
        "마.인언어학문입문(2)",
        "중급마.인어문법(2)",
        "중급말레이어듣기와말하기(2)",
        "중급멏티미디어마.인어(2)",
        "중급인도네시아어듣기와말하기(2)",
        "고급마.인어텍스트연습(2)",
        "고급말레이어읽기와쓰기",
        "고급인도네시아어읽기와쓰기",
        "마.인어관광통역",
        "마.인어희곡",
        "마.인역사(근현대사)",
        "마.인현대문학번역",
        "말레이세계의언어와문화",
        "FLEX마.인어",
        "마.인어시사번역연습(2)",
        "마.인지리문화의이해(2)",
        "마.인어문화예술번역(2)",
        "인도네시아사회제도",
      ],
      '문화콘텐츠학전공':[
        "다문화콘텐즈기획",
        "문화콘텐츠학입문",
        "상상력과문화콘텐츠",
        "지역과문화자원개발2",
        "문화콘텐츠기획",
        "문화콘텐츠와스토리텔링",
        "축제와문화콘텐츠2",
        "코리아타운과한류2",
        "출판콘텐츠분석과계발",
      ],
      '미국·영연방전략세부모듈':[
        "International Political Economy & Globalization",
        "Global Trends in the Media",
        "Political Culture of US & Britain",
        "Survey of American History",
        "Modern American & British Society",
        "The Commonwealth of Nations",
        "English for Conference",
      ],
      '바이오메디컬공학전공':[
        "디지털공학",
        "일반생물학2",
        "생체구조및생리학",
        "선형대수",
        "의용전자및실습",
        "의학유전학(의생명데이터프로그래밍)",
        "자료구조",
        "BME캡스톤기초실습",
        "바이오메디컬최신경향과창의설계",
        "바이오메디컬공학특강",
        "생체전기학",
        "웨어러브/임플란터블디바이스특론",
        "의료영상처리의이론및실습",
        "의생명자연어처리",
        "의생명정보학",
        "데이터시각화및실습",
        "신약개발",
      ],
      '반도체전자공학부(반도체공학전공)':[
        "반도체공학실험2",
        "반도체물리",
        "반도체회로1",
        "컴퓨터구조",
        "HDL응용설계",
      ],
      '반도체전자공학부(전자공학전공)':[
        "디지털공학",
        "물리전자",
        "신호및시스템",
        "전기회로",
        "전자공학실험",
        "컴퓨터구조",
        "공학설계프로그래밍",
        "디지털통신",
        "전자회로응용및실습",
        "집적회로공학",
        "프로세서응용종합설계",
        "Soc설계",
        "기계학습기반통신네크워크프로그래밍",
        "아날로그집적회로설계",
        "이동통신",
      ],
      '방송·영상·뉴미디어전공':[
        "대중예술과공연이해",
        "대중문화의이해",
        "엔터테이먼트산업트랜드분석",
        "온라인데이터커뮤니케이션",
        "콘텐츠리터러시"
      ],
      '브라질학과':[
        "브라질사",
        "초급포르투갈어문법작문(2)",
        "초급포르투갈어회화(2)",
        "브라질경제사",
        "중급포르투갈어강독(2)",
        "중급포르투갈어회화(2)",
        "Celpe-Bras/TPPB세미나II",
        "고급포르투갈어회화작문(2)",
        "브라질기업재무제표분석",
        "브라질대외경제관계론",
        "브라질금융시장론",
        "브라질사회문화세미나2",
        "브라질경제경영세미나2",
      ],
      '사학과':[
        "동양사강독",
        "서양생활문화사",
        "한국의역사가",
        "공공역사의이해",
        "미국의역사와문화",
        "서양고.중세사",
        "일본의역사와전통",
        "지역문화탐구",
        "한국근세사",
        "서양사특강",
        "중국중세사",
        "한국사회경제사",
        "고적답사",
        "동양사연습",
        "한국지역사",
      ],
      '산업경영공학과':[
        "공학경제",
        "비즈니스어낼리틱스입문",
        "데이터베이스설계및응용",
        "데이터사이언스개론",
        "생산계획및통제",
        "시뮬레이션",
        "딥러닝응용",
        "물류시스템",
        "실험계획분석",
        "최적화및강화학습실습",
        "텍스트어낼리틱스",
        "고급캡스톤디자인실습",
        "기술혁신전략및창업",
        "산업정보공학특론"
      ],
      '생명공학과':[
        "일반생물학2",
        "발생생물학",
        "분자생물학2",
        "생리학",
        "생명공학실험2",
        "일반미생물학2",
        "고급생명공학실험",
        "면역학",
        "분자생명공학특론",
        "생태학",
        "줄기세포생물학",
        "효소학",
        "미생물학적분해",
        "생명공학전공실습2",
        "생명공학특수연구및토론2",
      ],
      '서아프리카어전공':[
        "서아프리카개론",
        "하우사문법(초급)",
        "서아프리카음악",
        "UNESCO와ECOWAS",
        "사헬연구",
        "서아프리카:종족과문화적특성",
        "서아프리카이주와난민",
        "나이지리아-하우사권역세미나",
        "서아프리카이슬람의사회문화연구"
      ],
      '세계문화예술경영전공':[
        "문화미디에이션과로컬거버넌스",
        "한국영화텍스트분석",
        "미디어스토리텔링",
        "세게국공립극장정책과행정",
        "영화제현탐방과기획",
        "지역문화연출방법론",
        "논문세미나와토론",
        "전시기획론",
      ],
      '세르비아·크로아티아학과':{
        '전공': [
          "세르비아어문법과작문2",
          "세르비아어회화2",
          "세어번역연습2",
          "유고학입문2",
          "유고역사2",
          "크로아티아어문법작문2",
          "크로아티아어회화2",
          "크어번역연습2",
          "FLEX세르비아어",
          "시사세/크어",
          "크로아티아문학사",
          "크로아티아어B1-B2",
          "발칸유럽정치.경제",
          "유고문화연구세미나2",
          "유고지역연구2",
          "크로아티아문학사",
        ]
      },
      '수학과':[
        "논리와프로그래밍기초",
        "미적분학연습2",
        "거리공간론",
        "선형대수학및연습",
        "컴퓨팅사고입문",
        "해석학개론2",
        "기하학개론",
        "수학으로이해하는기계학습의원리2",
        "현대대수학1",
        "확률론",
        "수학논리및논술",
        "정수론",
        "채권수학",
      ],
      '스페인통번역학과':[
        "기초스페인어문법",
        "스페인어커뮤니케이션(2):읽기와쓰기",
        "스페인어통합실습",
        "스페인역사문화세미나(2)",
        "초급스페인어강독(2)",
        "초급스페인어문법(2)",
        "초급스페인어스피치실습(2)",
        "초급스페인어작문(2)",
        "초급스페인어회화(2)",
        "라틴아메리카역사세미나(2)",
        "매스미디어로본이베로아메리카(2)",
        "중급스페인어강독(2)",
        "중급스페인어문법(2)",
        "중급스페인어스피치실습(2)",
        "중급스페인어작문(2)",
        "중급스페인어회화(2)",
        "고급스페인어강독(2)",
        "고급스페인어청취(2)",
        "고급스페인어회화(2)",
        "라틴아메리카경제(2)",
        "라틴아메리카문화와사회사(2)",
        "라틴아메리카정치(2)",
        "스페인문학사(2)",
        "스페인어미디어통역",
        "스페인어언어학이해(2)",
        "이베로아메리카지역음악과미술(2)",
        "전공FLEX스페인어(2)",
        "픽션과영화로본이베로아메리카세계(2)",
        "라틴아메리카 주요인물연구",
        "라틴아메리카와미국",
        "스페인어고급문법세미나(2)",
        "스페인어발달사(2)",
        "스페인어순차통역(2)",
        "스페인어통번역세미나(2)",
        "이베로아메리카지역과EU정치경제(2)",
        "기초스페인어문법2(이중(부)전공)",
        "초급스페인어강독(2)(이중(부)전공)",
        "초급스페인어작문(2)(이중(부)전공)",
        "초급스페인어작문(2)(이중(부)전공)",
        "중급스페인어강독(2)(이중(부)전공)",
        "중급스페인어문법(2)(이중(부)전공)",
        "중급스페인어작문(2)(이중(부)전공)",
        "중급스페인어회화(2)(이중(부)전공)",
        "스페인어발달사(2)(이중(부)전공)",
      ],
      '아랍어통번역세부모듈':[
        "Elementary Arabic Conversation",
        "Elementary Arabic Grammer I",
        "Elementary Arabic-Korean Translation",
        "Introdution to Arabic Translation & Interpreting",
        "A Practice on Intermediate Colloquial Arabic",
        "Arabic Translation & Interpreting II",
        "Intermediate Arabic Conversation II",
        "Elementary Arabic-Korean Translation II",
        "Modern Arabic Reading I",
        "Advanced Practical Arabic",
        "Aradic in Multimedia II",
        "Korean-Arabic Consecutive Interpretation",
      ],
      '아프리카학부':[
        "아프리가인류학방법론"
      ],
      '언론·정보전공':[
        "미디어와정치",
        "알고리즘미디어와사회",
        "언론정보윤리와법",
      ],
      '언어인지과학과':[
        "언어와컴퓨터",
        "뇌와인지",
        "언어와통계",
        "언어자원과AI",
        "음운분석",
        "문장분석",
        "언어정보와처리",
        "언어학과언어교육",
        "언어학연습",
        "화용론",
        "법언어학",
        "언어학세미나",
      ],
      '영미권통상통번역전공':[
        "문화간커뮤니케이션",
        "산업IT번역",
      ],
      '영미문학·번역전공':[
        "문학번역의이해",
        "아동문학번역실습",
        "영.미문학과고전",
        "영.미희곡과공연예술",
        "셰익스피어",
        "영국소설",
        "영미문학과젠더",
        "번역과젠더",
        "영.미비평",
      ],
      '영어통번역세부모듈':[
        "English-Korean Translation",
        "Speaking for Interpreting",
        "Dialogue Interpreting",
        "English-Korean Consecutive Interpreting I",
        "Korean-English Translation I",
        "Advanced Korean & Critical Thinking",
        "Machine Translation & Post-editing",
        "T&I Theory & practice",
        "Translating Business & Economy-related", 
      ],
      '영어통번역학부':[
        "Foundation English Course 2",
        "기초통역연습",
        "영.미사회문화의기초",
        "영어글쓰기의기초",
        "영어읽기와토론",
        "영어프리젠테이션",
        "법률영어1",
        "스크린영어",
        "실용영문법",
        "영.미산문읽기",
        "플렉스및토익영작문",
        "상황별영어말하기",
        "영어교재연구및지도법",
        "영어능력평가와연습(2)",
        "취업영어(2)(인터뷰및토론)",
        "영어논리및논술",
      ],
      '영어통번역학전공':[
        "한.영시역",
        "고급시역과통역",
      ],
      '우크라이나학과':[
        "기초우크라이나아말하기(2)",
        "기초우크라이나어끄기와문법(2)",
        "디지털시대의우크라이나학(2)",
        "우크라이나역사와인물(2)",
        "우크라이나의국제통상",
        "중급우크라이나어문법작문(2)",
        "중급우크라이나어회화(2)",
        "우크라이나의시인과작가(2)",
        "우크라이나의전후재건",
        "카툰,멀티미디어로배우는중상위급우크라이나어(2)",
        "통번역연습(2)",
        "현대우크라이나문화코드의이해(2)",
        "흑해지역연구",
        "우크라이나지역연구세미나2",
        "발트-흑해역사문화",
        "우크라이나의문화유산과투어리즘",
        "우크라이나문화세미나2",
      ],
      '융합비즈니스세부모듈':[
        "Advanced Communication for Global Leaders",
        "Foundations of Marketing",
        "Global Business Enviroment and Management",
        "Theory and Practice for Entrepreneurial",
        "Innovation and Entrepreneurship for Convergence",
        "Management information Systems for Convergence Management",
        "Cultural Intelligence and Diverxity for Global Leaders",
        "Strategic Organizational Behavior for Global Entrepreneurs",
      ],
      '융합인재학부':[
        "Computer Technologies",
        "Global Culture & Future of Contents",
        "International Organization & Leadership",
        "Introduction to Business ond Convergence Management",
        "Translation, Interpreting & Future Industries",
        "Practicum of Career Writing & Presentation",
        "Practicum of Project for Graduation",
      ],
      '이탈리아·EU전략세부모듈':[
        "Italian & EU Culture I",
        "Italian Grammar I",
        "Italian-Korean Translation I",
        "Speaking Italian I",
        "Italian &EU industries",
        "Italian Grammer III",
        "Korean-Italian Translation I",
        "Speaking Italian III",
        "Fashion & Italian",
        "Tourism & Italian",
      ],
      '이탈리아어통번역학과':[
        "이탈리아어초급문법2",
        "전공교양토론2",
        "초급이탈리아어듣기2",
        "초급이탈리아어말하기2",
        "초급이탈리아어쓰기2",
        "초급이탈리아어읽기2",
        "이탈리아어문학작품읽기2",
        "전공교양세미나4",
        "중급이탈리아어듣기2",
        "중급이탈리아어말하기2",
        "중급이탈리아어쓰기2",
        "중급이탈리아어쓰읽기",
        "이탈리아명작의이해",
        "이탈리아문학사2",
        "이탈리아어번역실습2",
        "이탈리아어언어인증시험대비2",
        "이탈리아어통역실습2",
        "이탈리아역사2",
        "이탈리아정칭,경제,사회이해2",
        "이탈리아어주제별토론연습",
      ],
      '인도학과':[
        "인도사2",
        "초급힌디어II",
        "초급힌디어문법(2)",
        "인도교양입문(2)",
        "중급힌디어II",
        "중급힌디어문법(2)",
        "중급힌디어회화작문(2)",
        "FLEX힌디(2)",
        "고급힌디어작문(2)",
        "인도문화연구(2)",
        "인도지역연구(2)",
        "타밀어와남인도문화(2)",
        "힌디어회하실습(2)",
        "시사힌디어(2)",
        "인도경제(2)",
        "인도학세미나(2)",
      ],
      '일본어통번역학과':[],
      '전자물리학과':[],
      '정보통신공학과':[],
      '정치외교학과':[],
      '중국어통번역세부모듈':[],
      '중국어통번역학과':[],
      '중동·이슬람전략세부모듈':[],
      '중앙아시아학과':[],
      '중화권전략세부모듈':[],
      '철학과':[],
      '체코·슬로바키아학과':[],
      '컴퓨터공학전공':[
        /* 1학기 */
        "논리회로",
        "데이터사이언스기초",
        "자료구조",
        "전기회로",
        "전자기학",
        "프로그래밍어론",
        "데이터통신",
        "디지털신호처리",
        "빅데이터처리",
        "설계패턴",
        "시스템프로그래밍",
        "컴퓨터구조",
        "컴퓨터그래픽스",
        "컴퓨터비전개론",
        "IoT 시스템",
        "게임프로그래밍",
        "고급문제해결기법및실습",
        "그래프마이닝",
        "데이터베이스설계",
        "멀티코어컴퓨팅",
        "캡스톤설계및실습",
        /* 2학기 */
        "선형대수",
        "컴퓨터시스템입문",
        "객체지향프로그래밍",
        "기계학습",
        "마이크로프로세서및실습",
        "알고리즘",
        "웹프로그래밍",
        "데이터베이스",
        "딥러닝",
        "소프트웨어공학",
        "운영체제",
        "자연어처리",
        "컴파일러구성론",
        "컴퓨터네트워크",
        "SW연구프로젝트및실습",
        "강화학습기초",
        "모바일프로그래밍",
        "인공지능특강",
        "캡스톤설계및실습",
        "컴퓨터보안"
      ],
      '태국어통번역학과':[],
      '테크노미디어디자인세부모듈':[],
      '통계학과':[],
      '투어리즘 & 웰니스학부':[],
      '패션관광문화산업세부모듈':[],
      '프랑스학과':[],
      '행정학과':[],
      '헝가리학과':[],
      '화학과':[],
      '환경학과':[],
      '마이크로디그리(영어)':[],
      '언어와문학':[],
      '문화와예술':[],
      '역사와철학':[],
      '과학과기술':[],
      '인간과사회':[],
      '인성교육':[],
      'HUFS CAREER':[],
      '미래시뮬레이션':[],
      '실용외국어(선택)':[],
      '외국인을 위한 한국학':[],
      '생활과스포츠':[],
      '군사학':[],
      '대학외국어':[],
      '미네르바인문':[],
      'RC영어':[],
      '소프트웨어기초':[],
      'COLLEGE ENGLISH':[],
      '인문대학':[],
      '국가전략언어대학':[],
      '경상대학':[],
      '공과대학(공과계열)':[],
      'CULTURE&TECHNOLOGY융합대학':[],
      'AI융합대학':[],
      '폴란드학과':[],
      //'세르비아·크로아티아학과':[],
      '한국학과':[],
      '이공계열':[]
  },

   professor: {
        "선형대수" : [
          "김승욱",
          "정유진",
          "김성복"
        ],
        "컴퓨터시스템입문" : [
          "이재혁"
        ],
        "객체지향프로그래밍" : [
          "전병환"
        ],
        "기계학습" : [
          "김낙현"
        ],
        "마이크로프로세서및실습" : [
          "양승호"
        ],
        "알고리즘" : [
          "신찬수",
          "지수연",
        ],
        "웹프로그래밍" : [
          "MOHSEN ALI MOHSENALAWAMI",
          "지수연",
        ],
        "데이터베이스" : [
          "손기락",
        ],
        "딥러닝" : [
          "최재영",
          "장익범"
        ],
        "소프트웨어공학" : [
          "김상철",
        ],
        "운영체제" : [
          "이윤석",
          "임승호",
        ],
        "자연어처리" : [
          "김낙현",
          
        ],
        "컴파일러구성론" : [
          "Walid Abdullah AI",
        ],
        "컴퓨터네트워크" : [
          "MOHSEN ALI MOHSENALAWAMI"
        ],
        "SW연구프로젝트및실습" : [
          "장익범",
          "지수연",
        ],
        "강화학습기초" : [
          "전병환"
        ],
        "모바일프로그래밍" : [
          "Walid Abdullah AI"
        ],
        "인공지능특강" : [
          "장익범"
        ],
        "캡스톤설계및실습" : [
          "김승욱"
        ],
        "컴퓨터보안" : [
          "MOHSEN ALI MOHSENALAWAMI"
        ],
  }
};
export default dropdownOptions;